import { BaseApiResponse } from '@/models/generics';
import { TAddress } from '@/services/user/models/addresses';
import { TValue } from 'global';
import { TAppliedCoupon } from './../../offers/get-offers';

export enum CART_TYPE {
  RENT = 'RENTAL',
  BUY = 'BUY',
}

export type TCartData = {
  success: boolean;
  data: Data;
};

export type Data = {
  cart: TCart;

};

type MovCheckConfig = {
  failureCtx: {
    cta: {
      cartIcon: string;
      ctaIcon: string;
      ctaLink: string;
      descriptionForWeb: string;
    },
    titleForWeb: string;
  };
  value: string;
};

export type TCart = {
  applicableDiscounts: any;
  billingAddressDetails: TAddress;
  buyCart: TVerticalCart;
  canCheckout: boolean;
  errorMessage: string;
  ghostUserId: number;
  id: number;
  rentCart: TVerticalCart;
  serviceability: Serviceability;
  shippingAddressDetails: TAddress;
  // summary: TCartSummary;
  isAutopaySelected:boolean;
  isEligibleForAutopay:boolean;
  discrepancies:{
    message: string;
    type: "CITY_CHANGE" | "AVAILABILITY" | "SERVICEABILITY";
  }[]
  autopay: Autopay;
  total: TValue;
  totalCartItemsCount: number;
  totalSavings: TValue;
  userId: number;
  hasPassedMov: boolean;
  movCheck: MovCheckConfig;
  summary: {
    rentalBreakupSummaryTitleHeader?:any;
    rentalbreakupSummaryItemBlocks?:any
    breakupExplanation: BreakupExplanation;
    buyingBreakupDetailedTitleHeader: Breakup;
    buyingbreakupDetailedItemBlocks: Array<Breakup[]>;
    defaultSelectionForBreakup: string;
    rentalBreakupDetailedTitleHeader: Breakup;
    rentalbreakupDetailedItemBlocks: Array<Breakup[]>;
    totals: Array<Total[]>;
  };
  uiConfigurations:any
  emiEligibility:any
};

export type Offers = {
  applicableOffers: any[];
  bankOffers: TOffer[];
  ncEmiOffers: TOffer;
  nonApplicableOffers: TOffer[];
};

export type Summary = {
  lineItems: LineItem[][];
  totals: Total[][];
};

export type Total = {
  chargeAmount: TValue;
  chargeType: string;
  description: string;
  lineItemType: string;
  originalChargeAmount: TValue;
  type: string;
};

export type TCartValueAddedServices = {
  cta: string;
  description: string;
  selectedText: string;
  subtitle: string;
  title: string;
  type: VAS_TYPES;
  total: TValue;
};

//////////

export interface VerticalCartSummary {
  breakupDetailedItemBlocks: Array<Breakup[]>;
  breakupDetailedTitleHeader: Breakup;
  breakupExplanation: BreakupExplanation;
  breakupSummaryItemBlocks: any[];
  breakupSummaryTitleHeader: Breakup;
  defaultSelectionForBreakup: string;
  lineItems: Array<LineItem[]>;
  totals: Array<LineItem[]>;
}

export interface Breakup {
  backgroundColor: string;
  blockLineItems: BlockLineItem[] | null;
  preceedingSeparator: boolean;
  titleBlock: TitleBlock | null;
}

export interface BlockLineItem {
  subComponents: TitleBlock[];
}

export interface TitleBlock {
  alignment: Alignment;
  styles: LineItemStyles;
  value: string;
}

export enum Alignment {
  Left = "left",
  Middle = "middle",
  Right = "right",
}

export interface LineItemStyles {
  color: Color;
  fontSizeWeight: string;
  isUnderLined: boolean;
  strikedThrough: boolean;
}

export enum Color {
  The1D9428 = "#1d9428",
  The222222 = "#222222",
  The555555 = "#555555",
}

export interface BreakupExplanation {
  context: Context;
  linkText: string;
}

export interface Context {
  description: string;
  header: string;
  subText: string;
}

export interface LineItem {
  chargeAmount: TValue;
  chargeType: string;
  description: string;
  lineItemType: string;
  originalChargeAmount: TValue;
  type: string;
}

/////////////

export type TVerticalCart = {
  availableQuantity: number;
  appliedCoupon: TAppliedCoupon;
  offers: TCartOffers;
  rentalCartItems?: IRentCartItem[];
  rentalCartItemsCount?: number;
  buyCartItems?: IBuyCartItems[];
  buyCartItemsCount?: number;
  summary: VerticalCartSummary;
  total: TValue;
  totalSavings: TValue;
  valueAddedServices: TCartValueAddedServices[];
  tenureSelector?: any;
};

export type TCartOffers = {
  applicableOffers: TOffer[];
  bankOffers: TOffer[];
  ncEmiOffers: TOffer[];
  ncEmiOffer: TOffer;
  nonApplicableOffers: TOffer[];
};

export type TOffer = {
  code: string;
  cta: string;
  description: string;
  expiryText: string;
  header: string;
  id: number;
  image: string;
  longDescription: string;
  nonEligibilityReason: string;
  termsAndConditions: string[];
  type: string;
  whereToApply: string;
  savings: TValue;
  endDate: string;
};

// Cart item vas

export enum VAS_TYPES {
  FURLENCO_CARE_PROGRAM = 'FURLENCO_CARE_PROGRAM',
  FLEXI_CANCELLATION = 'FLEXI_CANCELLATION',
}

export type TCartItemApplicableValueAddedServices = {
  FLEXI_CANCELLATION: TCartItemVasDetails;
  FURLENCO_CARE_PROGRAM: TCartItemVasDetails;
};

export type TCartItemVasDetails = {
  additionalInfo: TCartItemVasAdditionalInfo;
  id: number;
  policies: TPolicy[];
  price: TValue;
  selected: boolean;
};

export type TCartItemVasAdditionalInfo = {
  description: string;
  label: string;
};

export type TPolicy = {
  key: string;
  termsAndConditions: string;
  value: string;
};

export enum LineOfProduct {
  RENT = "RENT",
  BUY_NEW = 'BUY_NEW',
  BUY_REFURBISHED = 'BUY_REFURBISHED'

}

export interface ICartItem {
  upfrontOffer: any;
  appliedDiscounts: any;
  availableQuantity: number;
  basePrice: TValue;
  discountPercentage: TValue;
  errorMessage: string;
  id: number;
  lineOfProduct: LineOfProduct;
  isOutOfStock: boolean;
  outOfStockErrMessage: string;
  product: TCartItemProduct;
  promisedDate: string;
  quantity: number;
  strikePrice: TValue;
  tenure: number;
  vertical: string;
  valueAddedServices: TCartItemApplicableValueAddedServices;
};

export interface IRentCartItem extends ICartItem {
  monthlyRentalPrice: TValue;
  upfrontOffer: any;
}

export interface IBuyCartItems extends ICartItem {
  sellingPrice: TValue;
};

export type TCartItemProduct = {
  configuration: string;
  id: number;
  image: string;
  name: string;
  permalink: string;
};

// export type UpfrontOffer = {
//   defaultTenure: number;
//   faqs: Faqs;
//   howItWorks: HowItWorks;
//   id: number;
//   knowMore: KnowMore;
//   paymentPlans: PaymentPlan[];
//   terms: Terms;
// };

export type Faqs = {
  details: Detail[];
  title?: string;
};

export type Detail = {
  answer: string;
  question: string;
};

export type HowItWorks = {
  details: Detail2[];
  title: string;
};

export type Detail2 = {
  description: string;
  header: string;
};

export type KnowMore = {
  details: Detail3[];
  title: string;
};

export type Detail3 = {
  description: string;
  header: string;
  image: string;
};

export type PaymentPlan = {
  isMostPopular?: boolean;
  isSelected?: boolean;
  monthlyRental: TValue;
  monthlySavings: TValue;
  productDiscountPercentage: TValue;
  strikePrice: TValue;
  tags: string[];
  tenure: number;
  totalSavings: TValue;
  upfrontDiscountPercentage: TValue;
};

export type Terms = {
  content: string[];
  title: string;
};

export type Serviceability = {
  errorMessage: string;
  serviceable: boolean;
};

export type Autopay = {
  isOfferAvailable:        boolean;
  maxMandateAmount:        Amount;
  maxMandateMultiplier:    number;
  monthlyRentalAmount:     Amount;
  supportedPaymentMethods: string[];
}

export type Amount = {
  displayValue: string;
  value:        number;
}


export interface IGetCartApiResponseData { cart: TCart; }
export type TGetCartApiResponse = BaseApiResponse<IGetCartApiResponseData>;